import * as React from 'react'
import FilterHeader from '../components/Inspections/FilterHeader'
import { Box, Typography } from '@mui/material'
import RequestsList from '../components/Inspections/RequestsList'
import { InspectionsLogProvider } from '../components/Inspections/InspectionsLogContext'
import { ManageQCWorkersDialog } from '../components/Inspections/ManageQCWorkersDialog'

const PAGE_LAYOUT_SX = {
	display: 'flex',
	flexDirection: 'column',
	height: 'calc(100vh - 64px)',
	overflow: 'hidden',
} as const

const TITLE_SX = {
	fontSize: '1.5rem',
	paddingLeft: '1rem',
	paddingTop: '.5rem',
	zIndex: '3',
} as const

export default function InspectionsLogPage() {
	return (
		<InspectionsLogProvider>
			<Box sx={PAGE_LAYOUT_SX}>
				<Box display="flex" justifyContent="space-between">
					<Typography sx={TITLE_SX}>Inspections</Typography>
					<ManageQCWorkersDialog />
				</Box>
				<FilterHeader />
				<Box sx={{ flex: 1, overflowY: 'auto' }}>
					<RequestsList />
				</Box>
			</Box>
		</InspectionsLogProvider>
	)
}
